// extracted by mini-css-extract-plugin
export default {"gridGroup":"gridGroup_gridGroup__dEewC"};